module.exports = __webpack_public_path__ + "static/img/jp_zhsl.88e8a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_zhsl.png
// module id = 6rcX
// module chunks = 1